export default __webpack_public_path__ + "static/media/2022-12-09-youtube-community-guidelines.752111f1.md";